import { myListsEditListFormStyles } from "@insite/content-library/Widgets/MyLists/MyListsEditListForm";

myListsEditListFormStyles.container = {
    ...myListsEditListFormStyles.container,

    gap: 10,
};

myListsEditListFormStyles.cancelButton = {
    ...myListsEditListFormStyles.cancelButton,

    variant: "secondary",
};
